// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__formContainer___O5pQq {
    align-items: center;
    display: flex;
    flex-direction: column;
}

.style__buttonsContainer___zIrHI {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 40px;
    margin-bottom: 20px;
}

.style__methodContainer___qiVMY {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: rgb(240, 240, 240);
    padding: 10px;
    width: 225px;
    margin-left: 17px;
    margin-right: 17px;
    /*padding: 8px 0;*/
    border-radius: 8px;
    border: 0px solid var(--black);
}

.style__countryContainer___OlITu {
    border-top: 1px solid lightgrey;
    border-bottom: 1px solid lightgrey;
    padding-top: 16px;
    padding-bottom: 16px;
    margin-top: 16px;
    justify-content: center;
    width: 520px;
}

.style__title___R5bqE {
    font-size: 18px;
    /*margin-top: 2vh;*/
    /*margin-bottom: 2vh;*/
}

.style__description___RIhsO {
    font-size: 22px;
    text-align: center;
    margin-top: 40px;
}

.style__codeInput___MvPkg {
    border: 0;
    border-bottom: 1px solid lightgrey;
    border-right: 1px solid lightgrey;
    font-size: 18px;
    height: 64px;
    text-align: center;
    width: 86px;
    outline: none;
}

.style__phoneInput___VsMio {
    font-size: 18px;
    background-color: #fff;
    padding-left: 8px;
    padding-right: 8px;
    align-self: center;
    border: 0;
    border-bottom: 1px solid lightgrey;
    height: 64px;
    width: 432px;
    outline: none;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
}

.style__separatorContainer___mz2bP {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 8px 0;
}

.style__line___w_HKL {
    width: 240px;
    height: 1px;
    background-color: lightgrey;
}

.style__orText___iG7RK {
    color: grey;
    padding: 0 8px;
}


.style__sticknetIcon___JOgQl {
    border-radius: 60px;
    width: 100px;
    height: 100px;
    margin-top: 40px;
}


/* CODE INPUT FORM */

.style__pinContainer___prxzI {
    display: flex;
    margin-top: 40px;
    margin-bottom: 40px;
}

.style__pinInput___osICy {
    width: 40px;
    height: 40px;
    font-size: 24px;
    text-align: center;
    margin-right: 10px;
    border: 1px solid #6060FF;
    outline: none;
    transition: border-color 0.3s;
}

.style__pinInput___osICy:focus {
    background-color: #9090ff;
    animation: style__scaleUpDown___rQjNM 0.5s infinite alternate;
}

@keyframes style__scaleUpDown___rQjNM {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(1.1);
    }
}

.style__resend___l1po3 {
    font-size: 16px;
    color: grey;
    text-align: center;
    margin-top: 32px;
    background-color: transparent;
    border: none;
}


/*Password Input*/

.style__keyCircle___nj5jZ {
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--primary-color);
    border-radius: 50%;
    margin-top: 40px;
}

.style__input____KZpR {
    width: 432px;
    padding: 10px;
    font-size: 16px;
    border: none;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
    margin-top: 32vh;
}

.style__input____KZpR::placeholder {
    color: #bbb;
}

.style__input____KZpR:focus {
    outline: none;
    box-shadow: 4px 4px 8px 4px rgba(0, 0, 0, 0.2);
}

.style__dont____fDrI {
    color: grey;
    text-decoration: underline;
    margin-top: 48px;
}

.style__qrInfo___KgVeX {
    font-size: 20px;
    margin-top: 32px;
}

.style__storeContainer___s9Ftl {
    display: flex;
    flex-direction: row;
    margin-top: 40px;
    justify-content: space-between;
}

.style__store___CH0Hd {
    width: 150px;
    height: 50px;
    border: 1px solid grey;
    border-radius: 10px;
    margin: 0px 60px;
    background: #000000;
}

/*Password Recovery*/

.style__deviceItem___C4Jpn {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: flex-start;
    margin-bottom: 12px;
}

.style__deviceName___nlt0h {
    font-weight: bold;
    color: var(--black)
}
`, "",{"version":3,"sources":["webpack://./src/client/LoginScreen/style.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;IAClC,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kCAAkC;IAClC,iCAAiC;IACjC,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B,EAAE,YAAY;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;;AAGA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;;AAGA,oBAAoB;;AAEpB;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,6DAA8C;AAClD;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;AAChB;;;AAGA,iBAAiB;;AAEjB;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,8CAA8C;IAC9C,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB;AACJ","sourcesContent":[".formContainer {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n}\n\n.buttonsContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-top: 40px;\n    margin-bottom: 20px;\n}\n\n.methodContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    background-color: rgb(240, 240, 240);\n    padding: 10px;\n    width: 225px;\n    margin-left: 17px;\n    margin-right: 17px;\n    /*padding: 8px 0;*/\n    border-radius: 8px;\n    border: 0px solid var(--black);\n}\n\n.countryContainer {\n    border-top: 1px solid lightgrey;\n    border-bottom: 1px solid lightgrey;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    margin-top: 16px;\n    justify-content: center;\n    width: 520px;\n}\n\n.title {\n    font-size: 18px;\n    /*margin-top: 2vh;*/\n    /*margin-bottom: 2vh;*/\n}\n\n.description {\n    font-size: 22px;\n    text-align: center;\n    margin-top: 40px;\n}\n\n.codeInput {\n    border: 0;\n    border-bottom: 1px solid lightgrey;\n    border-right: 1px solid lightgrey;\n    font-size: 18px;\n    height: 64px;\n    text-align: center;\n    width: 86px;\n    outline: none;\n}\n\n.phoneInput {\n    font-size: 18px;\n    background-color: #fff;\n    padding-left: 8px;\n    padding-right: 8px;\n    align-self: center;\n    border: 0;\n    border-bottom: 1px solid lightgrey;\n    height: 64px;\n    width: 432px;\n    outline: none;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\ninput[type=\"number\"] {\n    -moz-appearance: textfield; /* Firefox */\n}\n\n.separatorContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 8px 0;\n}\n\n.line {\n    width: 240px;\n    height: 1px;\n    background-color: lightgrey;\n}\n\n.orText {\n    color: grey;\n    padding: 0 8px;\n}\n\n\n.sticknetIcon {\n    border-radius: 60px;\n    width: 100px;\n    height: 100px;\n    margin-top: 40px;\n}\n\n\n/* CODE INPUT FORM */\n\n.pinContainer {\n    display: flex;\n    margin-top: 40px;\n    margin-bottom: 40px;\n}\n\n.pinInput {\n    width: 40px;\n    height: 40px;\n    font-size: 24px;\n    text-align: center;\n    margin-right: 10px;\n    border: 1px solid #6060FF;\n    outline: none;\n    transition: border-color 0.3s;\n}\n\n.pinInput:focus {\n    background-color: #9090ff;\n    animation: scaleUpDown 0.5s infinite alternate;\n}\n\n@keyframes scaleUpDown {\n    0% {\n        transform: scale(1);\n    }\n    100% {\n        transform: scale(1.1);\n    }\n}\n\n.resend {\n    font-size: 16px;\n    color: grey;\n    text-align: center;\n    margin-top: 32px;\n    background-color: transparent;\n    border: none;\n}\n\n\n/*Password Input*/\n\n.keyCircle {\n    width: 120px;\n    height: 120px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid var(--primary-color);\n    border-radius: 50%;\n    margin-top: 40px;\n}\n\n.input {\n    width: 432px;\n    padding: 10px;\n    font-size: 16px;\n    border: none;\n    border-radius: 8px;\n    background-color: #fff;\n    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.1);\n    transition: box-shadow 0.3s ease;\n    margin-top: 32vh;\n}\n\n.input::placeholder {\n    color: #bbb;\n}\n\n.input:focus {\n    outline: none;\n    box-shadow: 4px 4px 8px 4px rgba(0, 0, 0, 0.2);\n}\n\n.dont {\n    color: grey;\n    text-decoration: underline;\n    margin-top: 48px;\n}\n\n.qrInfo {\n    font-size: 20px;\n    margin-top: 32px;\n}\n\n.storeContainer {\n    display: flex;\n    flex-direction: row;\n    margin-top: 40px;\n    justify-content: space-between;\n}\n\n.store {\n    width: 150px;\n    height: 50px;\n    border: 1px solid grey;\n    border-radius: 10px;\n    margin: 0px 60px;\n    background: #000000;\n}\n\n/*Password Recovery*/\n\n.deviceItem {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    align-self: flex-start;\n    margin-bottom: 12px;\n}\n\n.deviceName {\n    font-weight: bold;\n    color: var(--black)\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `style__formContainer___O5pQq`,
	"buttonsContainer": `style__buttonsContainer___zIrHI`,
	"methodContainer": `style__methodContainer___qiVMY`,
	"countryContainer": `style__countryContainer___OlITu`,
	"title": `style__title___R5bqE`,
	"description": `style__description___RIhsO`,
	"codeInput": `style__codeInput___MvPkg`,
	"phoneInput": `style__phoneInput___VsMio`,
	"separatorContainer": `style__separatorContainer___mz2bP`,
	"line": `style__line___w_HKL`,
	"orText": `style__orText___iG7RK`,
	"sticknetIcon": `style__sticknetIcon___JOgQl`,
	"pinContainer": `style__pinContainer___prxzI`,
	"pinInput": `style__pinInput___osICy`,
	"scaleUpDown": `style__scaleUpDown___rQjNM`,
	"resend": `style__resend___l1po3`,
	"keyCircle": `style__keyCircle___nj5jZ`,
	"input": `style__input____KZpR`,
	"dont": `style__dont____fDrI`,
	"qrInfo": `style__qrInfo___KgVeX`,
	"storeContainer": `style__storeContainer___s9Ftl`,
	"store": `style__store___CH0Hd`,
	"deviceItem": `style__deviceItem___C4Jpn`,
	"deviceName": `style__deviceName___nlt0h`
};
export default ___CSS_LOADER_EXPORT___;
